"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAddressCheckManagementRow = void 0;
class OrderAddressCheckManagementRow {
}
exports.OrderAddressCheckManagementRow = OrderAddressCheckManagementRow;
//# sourceMappingURL=order-address-check-management-row.js.map